'use client'

import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import Cookies from 'js-cookie'
import { FC, useEffect, useState } from 'react'

//import StoryblokClient from 'storyblok-js-client'
//const Storyblok = new StoryblokClient({ accessToken: process.env.NEXT_PUBLIC_SB_PREVIEW_TOKEN })
import { storyblokRichText } from '../../../utilities/richText'
import { PhnxButton } from '../Button/Button'
import styles from './Gatecontent.module.css'

interface GatecontentBlokProps {
  blok: {
    Ungate: boolean
    bttonText: string
    cookieAccessKey: string
    downloadLink: { url: string }
    flipsnackEmbed: string
    description: any
    buttonAlignment?: 'left' | 'center'
  } & SbBlokData
  isInsideStoryblok: any
}

const Gatecontent: FC<GatecontentBlokProps> = ({ blok, isInsideStoryblok }) => {
  const [contentVisible, setContentVisible] = useState(false)

  let renderedDescription = ''
  try {
    if (blok.description) {
      const rendered = storyblokRichText.render(blok.description)
      renderedDescription = typeof rendered === 'string' ? rendered : ''
    }
  } catch (error) {
    console.warn('Error rendering rich text:', error)
    renderedDescription = ''
  }

  const hasDescription =
    renderedDescription &&
    renderedDescription.trim() !== '' &&
    renderedDescription.trim() !== '<p></p>'
  const isDescriptionEmpty =
    !renderedDescription || renderedDescription.trim() === '' || renderedDescription === '<p></p>'

  useEffect(() => {
    // if isInsideStoryblok is true ignore this
    if (isInsideStoryblok) {
      setContentVisible(true)
      return
    }
    if (blok.Ungate) {
      setContentVisible(true)
      return
    }

    const cookie = Cookies.get('form-cookie')

    if (
      cookie !== undefined &&
      (blok.cookieAccessKey === undefined ||
        blok.cookieAccessKey === '' ||
        blok.cookieAccessKey === cookie)
    ) {
      setContentVisible(true)
    } else {
      // go back to the home page
      window.location.href = '/'
    }
  }, [blok, isInsideStoryblok])

  return (
    <div {...storyblokEditable(blok)} id="gated-content" className={styles.gatedContent}>
      {contentVisible && (
        <div
          id="gated-content-body"
          className={`${styles.gatedContentBg} ${
            hasDescription ? `${styles.gatedContentCopy} container` : ''
          }`}
        >
          {hasDescription && (
            <div
              className={`${styles.gatedContentCopyRich} text-left`}
              dangerouslySetInnerHTML={{ __html: renderedDescription }}
            />
          )}

          {blok.downloadLink?.url && blok.bttonText && (
            <div
              className={`${styles.btn} ${
                blok.buttonAlignment === 'center' ? styles.btnCenter : styles.btnLeft
              }`}
            >
              <PhnxButton
                type="link"
                variant="primary"
                label={blok.bttonText}
                href={blok.downloadLink.url}
                openInNewWindow={true}
              />
            </div>
          )}
        </div>
      )}
      {contentVisible && blok.flipsnackEmbed && isDescriptionEmpty && (
        <div
          id="gated-content-container"
          className={styles.gatedContentContainer}
          dangerouslySetInnerHTML={{
            __html: blok.flipsnackEmbed,
          }}
        />
      )}
    </div>
  )
}

export default Gatecontent
